import React, { useState } from 'react';
import { FiClock } from 'react-icons/fi';

// Horários em que a APROVAÇÃO da carteirinha acontece. O pagamento pode ser
// feito a qualquer hora — só a aprovação segue esses horários.
export const HORARIOS_APROVACAO = [
    { dia: 'Segunda a sexta', hora: '8h às 23h59' },
    { dia: 'Sábado', hora: '8h às 14h' },
    { dia: 'Domingo', hora: '12h às 15h' },
];

// Componente reutilizável. Layouts:
//   variant="chip"   — pill discreto com clock; clica e abre um popover com os
//                      horários (usado ao lado do título da página de Produtos)
//   variant="footer" — versão compacta pro rodapé
//   variant="card"   — banner destacado (não usado hoje, mantido por reuso)
export default function HorarioFuncionamento({ variant = 'chip' }) {
    const [aberto, setAberto] = useState(false);

    if (variant === 'chip') {
        return (
            <span
                style={styles.chipWrap}
                onMouseEnter={() => setAberto(true)}
                onMouseLeave={() => setAberto(false)}
            >
                <button
                    type="button"
                    style={styles.chip}
                    onClick={() => setAberto(v => !v)}
                    aria-label="Ver horário de aprovação"
                >
                    <FiClock size={13} />
                    <span>Horário de aprovação</span>
                </button>
                {aberto && (
                    <span style={styles.popover}>
                        <span style={styles.popoverTitle}>Aprovação da carteirinha</span>
                        {HORARIOS_APROVACAO.map((h) => (
                            <span key={h.dia} style={styles.popoverLinha}>
                                <span style={styles.popoverDia}>{h.dia}</span>
                                <b style={styles.popoverHora}>{h.hora}</b>
                            </span>
                        ))}
                        <span style={styles.popoverNota}>
                            Pague quando quiser — a aprovação ocorre nesses horários.
                        </span>
                    </span>
                )}
            </span>
        );
    }

    if (variant === 'footer') {
        return (
            <div style={styles.footerWrap}>
                {HORARIOS_APROVACAO.map((h) => (
                    <div key={h.dia} style={styles.footerLine}>
                        <span style={styles.footerDia}>{h.dia}</span>
                        <span style={styles.footerHora}>{h.hora}</span>
                    </div>
                ))}
                <p style={styles.footerNota}>
                    Você pode pagar a qualquer hora — a aprovação ocorre nesses horários.
                </p>
            </div>
        );
    }

    return (
        <div style={styles.card}>
            <div style={styles.cardHeader}>
                <span style={styles.iconBox}><FiClock size={18} /></span>
                <div>
                    <div style={styles.cardTitle}>Horário de aprovação</div>
                    <div style={styles.cardSubtitle}>
                        Pague quando quiser — a aprovação da sua carteirinha acontece nestes horários:
                    </div>
                </div>
            </div>
            <div style={styles.linhas}>
                {HORARIOS_APROVACAO.map((h) => (
                    <div key={h.dia} style={styles.linha}>
                        <span style={styles.dia}>{h.dia}</span>
                        <b style={styles.hora}>{h.hora}</b>
                    </div>
                ))}
            </div>
        </div>
    );
}

const styles = {
    // ---- variant chip (discreto, ao lado do título) ----
    chipWrap: { position: 'relative', display: 'inline-flex' },
    chip: {
        display: 'inline-flex', alignItems: 'center', gap: 5,
        padding: '4px 10px', borderRadius: 999,
        background: '#ECFDF5', border: '1px solid #A7F3D0',
        color: '#047857', fontSize: '0.74rem', fontWeight: 600,
        cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap',
        lineHeight: 1.2,
    },
    popover: {
        position: 'absolute', top: 'calc(100% + 6px)', left: 0, zIndex: 30,
        display: 'flex', flexDirection: 'column', gap: 4,
        minWidth: 220, padding: '10px 12px',
        background: '#FFFFFF', border: '1px solid #E2E8F0', borderRadius: 10,
        boxShadow: '0 10px 28px -8px rgba(15,23,42,0.25)',
    },
    popoverTitle: {
        fontSize: '0.72rem', fontWeight: 800, color: '#0F172A',
        textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 2,
    },
    popoverLinha: {
        display: 'flex', justifyContent: 'space-between', gap: 14,
        fontSize: '0.82rem', color: '#475569',
    },
    popoverDia: { whiteSpace: 'nowrap' },
    popoverHora: { color: '#065F46', whiteSpace: 'nowrap' },
    popoverNota: {
        fontSize: '0.7rem', color: '#94A3B8', marginTop: 4, lineHeight: 1.4,
    },

    // ---- variant card (banner) ----
    card: {
        background: '#ECFDF5',
        border: '1px solid #A7F3D0',
        borderRadius: 12,
        padding: '1rem 1.1rem',
        marginBottom: '1.5rem',
    },
    cardHeader: {
        display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: 12,
    },
    iconBox: {
        width: 36, height: 36, borderRadius: 9, flexShrink: 0,
        background: 'linear-gradient(135deg, #059669, #10B981)',
        color: '#FFFFFF', display: 'grid', placeItems: 'center',
    },
    cardTitle: { fontWeight: 800, color: '#065F46', fontSize: '0.98rem' },
    cardSubtitle: { fontSize: '0.82rem', color: '#047857', marginTop: 2, lineHeight: 1.45 },
    linhas: { display: 'flex', flexDirection: 'column', gap: 4 },
    linha: {
        display: 'flex', justifyContent: 'space-between',
        fontSize: '0.88rem', color: '#065F46',
        padding: '5px 0', borderTop: '1px dashed #A7F3D0',
    },
    dia: { color: '#047857' },
    hora: { color: '#065F46' },

    // ---- variant footer (compacto) ----
    footerWrap: { display: 'flex', flexDirection: 'column', gap: 4 },
    footerLine: {
        display: 'flex', justifyContent: 'space-between', gap: 12,
        fontSize: '0.82rem', color: 'rgba(255,255,255,0.85)',
    },
    footerDia: { whiteSpace: 'nowrap' },
    footerHora: { fontWeight: 700, color: '#FFFFFF', whiteSpace: 'nowrap' },
    footerNota: {
        fontSize: '0.72rem', color: 'rgba(255,255,255,0.6)',
        marginTop: 6, lineHeight: 1.4,
    },
};
